/**
 * 회원 탈퇴 2단계 (/m/member/leave2) — 남은 캐시 출금 요청·탈퇴
 * ($j.Pages.Mobile.MemberLeave2 / body data-page-name="MemberLeave2")
 */
export default class MemberLeave2 {
    initialize() {
        const D = JSON.parse(document.getElementById('page-data')?.textContent || '{}');   // 서버 값 (#page-data)

        $(function () {
            const memCash = D.memCash;
            const $agree = $('#lv-nocash');
            const $leave = $('#lv-leave');
            const $hint = $('#lv-hint');
            const $withdraw = $('#lv-withdraw');

            function refresh() {
                if (memCash <= 0) return;
                const ok = $agree.hasClass('is-on');
                $hint.text(ok ? '' : '출금을 요청하거나, 출금 없이 탈퇴하는 데 동의해 주세요');
                $leave.prop('disabled', !ok);
            }

            $agree.on('click keydown', function (e) {
                if (e.type === 'keydown' && e.key !== ' ' && e.key !== 'Enter') return;
                e.preventDefault();
                const on = !$agree.hasClass('is-on');
                $agree.toggleClass('is-on', on).attr('aria-checked', on ? 'true' : 'false');
                refresh();
            });

            // 탈퇴 취소 — 이 화면으로 되돌아오지 않게 replace (CLAUDE.md 페이지 이동)
            $('.lv-cancel').on('click', function (e) { e.preventDefault(); location.replace(this.href); });

            $withdraw.on('click', function () {
                if ($withdraw.prop('disabled')) return;
                $withdraw.prop('disabled', true);
                $.post('/m/ajax/account/exchange', { amount: memCash })
                    .done(function (data) {
                        if (data && data.result) {
                            $j.Common.Util.swalert(
                                '전액 출금을 접수했어요.\n평일 09:00~17:00 에 3시간 안에 처리돼요 (주말·공휴일 제외).',
                                function () { location.reload(); }
                            );
                            return;
                        }
                        $j.Common.Util.swalert((data && data.message) || '출금 요청을 하지 못했어요.', function () { location.reload(); });
                    })
                    .fail(function () {
                        $withdraw.prop('disabled', false);
                        $j.Common.Util.swalert('처리하지 못했어요.\n잠시 후 다시 시도해 주세요.');
                    });
            });

            function leaveRequest() {
                $leave.prop('disabled', true).addClass('is-loading');
                $.post('/m/member/wait')
                    .done(function () { location.replace('/m/member/wait'); })
                    .fail(function () {
                        $leave.prop('disabled', false).removeClass('is-loading');
                        $j.Common.Util.swalert('탈퇴 요청 중 오류가 났어요.\n잠시 후 다시 시도해 주세요.');
                    });
            }

            $leave.on('click', async function () {
                if ($leave.prop('disabled')) return;
                if (memCash > 0) {
                    const ok = await $j.Ui.Dialog.confirm('이대로 탈퇴할까요?', {
                        tone:    'warn',
                        desc:    '남은 충전금 ' + memCash.toLocaleString() + '원은 탈퇴 후 환불할 수 없어요.',
                        confirm: '탈퇴',
                        cancel:  '취소',
                    });
                    if (!ok) return;
                }
                leaveRequest();
            });
        });

    }
}
